@let i18nPrefix = "shared.navigation_bar.org_selector";

<div class="dev-org-selector">
  <app-search-box
    [label]="`${i18nPrefix}.search_orgs` | translate"
    placeholder="Inseer, Inc."
    [(ngModel)]="searchQuery"
  />

  @if (loadingOrgs()) {
    <p>{{ `${i18nPrefix}.loading_orgs` | translate }}</p>
  } @else {
    <mat-selection-list
      class="org-list"
      [multiple]="false"
      hideSingleSelectionIndicator
      (selectionChange)="onSelectionChange($event)"
    >
      @for (org of filteredOrgs(); track org._id) {
        <mat-list-option
          [value]="org._id"
          [selected]="org._id === selectedOrgId()"
          [class.selected]="org._id === selectedOrgId()"
        >
          {{ orgDisplayFn(org) }}
          @if (org._id === selectedOrgId()) {
            <span matListItemMeta>
              <mat-icon>check</mat-icon>
            </span>
          }
        </mat-list-option>
      }
    </mat-selection-list>
  }

  @if (isNonHomeOrgSelected()) {
    <button
      class="home-org-button"
      mat-stroked-button
      color="primary"
      type="button"
      (click)="switchToHomeOrg()"
    >
      {{ `${i18nPrefix}.switch_to_home_org` | translate }}
    </button>
  }
</div>
